export default __webpack_public_path__ + "static/media/DSC09723.cd57cad8.JPG";